///-- THIS FILE IS GENERATED --///
export enum Appearance {

    APPEARANCE_NONE = "pinata-appearance-none",

}